import DataTable from './data-table';

// A small extension of DataTable that supports scenarios where all
// data is pre-loaded when creating the table. It will automatically setup
// and paginate data.
//
// See PaymentHistoryTable and ReportPreviewTable for implementations
export default class InMemoryTable extends DataTable {
  constructor(data, el, options) {
    super(data, el, options);

    this.updatePagination();
  }

  paginationChanged(goToFirstPage=false){
    if (goToFirstPage) {
      this.selectedPage(1);
    }
    const selectedPer = parseInt(this.selectedPer());
    const startIndex = (this.selectedPage() - 1) * selectedPer;
    const endIndex = startIndex + selectedPer;
    this.rows(this.allRows.slice(startIndex, endIndex));
    if (this.selectedPage() == 1) {
      this.firstPage(true);
    } else {
      this.firstPage(false);
    }
    if ((this.selectedPage() - 1) * selectedPer + selectedPer < this.allRows.length) {
      this.lastPage(false);
    } else {
      this.lastPage(true);
    }
  }

  updatePagination() {
    this.allRows = this.rows();

    this.firstPage(true);

    const perPage = parseFloat(this.selectedPer());

    this.rows(this.allRows.slice(0,perPage));

    if (perPage >= this.allRows.length) {
      this.lastPage(true);
    }
  }

  paginationText(){
    const selectedPer = parseInt(this.selectedPer());
    const startIndex = (this.selectedPage() - 1) * selectedPer;
    let endIndex = startIndex + selectedPer;
    const total = this.allRows.length;
    endIndex = Math.min(total, endIndex);
    return `${startIndex+1}-${endIndex} of ${total}`;
  }
}

